/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agenda_MinutesInputs */



/**
* | output |
* | --- |
* | "{count} min" |
*
* @param {Agenda_MinutesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_minutes = /** @type {((inputs: Agenda_MinutesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_MinutesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.count} min`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} min`)
	return /** @type {LocalizedString} */ (`${i?.count} min`)
});